module.exports = __webpack_public_path__ + "resources/img/img_security_dfinder_fds2_m.85d324fb400642406ae6762715aee98a.png";